<template>
  <div>
    <ul v-if="_conditions"></ul>
    <li v-for="(condition, index) in _conditions" :key="index">
      <span
        class="conditions"
        @click="setCondition(condition)"
        v-bind:class="{ active: condition.check }"
      >
        {{ condition.text }}
      </span>
    </li>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Public",
  props: {
    _conditions: Array,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["items", "conditions"]),
  },
  methods: {
    setCondition(condition) {
      let key = this.getKeyByValue(this.conditions, condition.text);
      this.$store.commit("condition", { id: key, bool: !condition.check });
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find((key) => object[key].text === value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/_shared_private.scss";
@import "../scss/_variables.scss";

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: $margin-default $margin-default;
}
</style>
